import React, { CSSProperties } from 'react';

import classNames from 'classnames';

import styles from './Skeleton.module.css';

type SkeletonProps = {
  count?: number;
  lastLineLength?: 'short' | 'medium' | number;
  screenReaderText?: string;
  className?: string;
  style?: CSSProperties;
  circle?: boolean;
  size?: number;
};

/**
 * @experiemental Component show Loading State
 */
export const Skeleton = ({
  count = 1,
  lastLineLength,
  screenReaderText = 'Loading',
  circle,
  size,
  className,
  style,
}: SkeletonProps) => {
  const getStyles = (isLast: boolean) => {
    let styles: CSSProperties = {};
    if (lastLineLength && isLast) {
      let width = '';
      switch (lastLineLength) {
        case 'short':
          width = '35%';
          break;
        case 'medium':
          width = '70%';
          break;
        default:
          width = `${lastLineLength}%`;
      }
      styles.width = width;
    }
    if (size) {
      styles.width = `${size}px`;
    }
    if (style) {
      styles = {
        ...styles,
        ...style,
      };
    }
    return styles;
  };

  return (
    <div className={styles.skeleton}>
      {new Array(count).fill(null).map((_, i) => (
        <div
          className={classNames(
            styles.row,
            styles.shimmer,
            { [styles.circle]: circle },
            className,
          )}
          style={getStyles(i === count - 1)}
          key={`skeleton_line_${i}`}
        >
          {screenReaderText}
        </div>
      ))}
    </div>
  );
};
